var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.shouldDisplayNonPrintComponent
      ? {}
      : { margin: 0, padding: 0, overflow: 'initial' }),attrs:{"id":"app"}},[(_vm.shouldDisplay)?_c('s-menu'):_vm._e(),(_vm.shouldDisplay)?_c('phil-collins'):_vm._e(),_c('main',{staticClass:"Main",style:(_vm.shouldDisplayNonPrintComponent
        ? {}
        : { margin: 0, padding: 0, overflow: 'initial' })},[_c('router-view')],1),(_vm.shouldDisplay)?_c('basket'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }